module.exports = __webpack_public_path__ + "media/customize/banner-modern-top-92502f5e.svg";